import { createContext } from 'react';

export interface AuthUser {
	email: string;
	name: string;
	isAdmin: boolean;
	/** False when the user is authenticated but has no roles in the org. */
	hasRoles: boolean;
}

export interface AuthContextValue {
	user: AuthUser | null;
	signOut: () => void;
	accountActionLabel: string;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
